import { zollBaseURL } from '../../../services/api.service'
import { ZollAPIService } from '../../../services/zollApi.service'
import {
  IPulsaraRecordsRequest,
  IPulsaraRecordsResponse,
  IPulsaraDetailsRequest,
  IPulsaraDetailsResponse,
  IPulsaraAttachmentsRequest,
  IPulsaraAttachmentsResponse,
  IPulsaraAttachmentImageRequest,
  IPulsaraAttachmentImageResponse,
} from '../store/pulsara.types'

const PULSARA_BASE_URL = `${zollBaseURL}/api/Pulsara`
const fetchPulsaraRecordsUrl = (data: IPulsaraRecordsRequest) =>
  `${PULSARA_BASE_URL}/patient-channels?startDate=${data.startDate}&endDate=${data.endDate}`
const fetchPulsaraDetailsUrl = (pulsaraId: string | number) => `${PULSARA_BASE_URL}/patient-channel/${pulsaraId}`
const fetchPulsaraAttachmentsUrl = (pulsaraId: string | number) => `${PULSARA_BASE_URL}/attachments/${pulsaraId}`
const fetchPulsaraAttachmentImageUrl = (pulsaraId: string | number, attachmentId: number) =>
  `${PULSARA_BASE_URL}/attachments/${pulsaraId}/${attachmentId}`

export class PulsaraService extends ZollAPIService {
  async fetchPulsaraRecords(data: IPulsaraRecordsRequest): Promise<IPulsaraRecordsResponse> {
    return this.get(fetchPulsaraRecordsUrl(data))
  }

  async fetchPulsaraDetails(data: IPulsaraDetailsRequest): Promise<IPulsaraDetailsResponse> {
    return this.get(fetchPulsaraDetailsUrl(data.pulsaraId))
  }

  async fetchPulsaraAttachments(data: IPulsaraAttachmentsRequest): Promise<IPulsaraAttachmentsResponse> {
    return this.get(fetchPulsaraAttachmentsUrl(data.pulsaraId))
  }

  async fetchPulsaraAttachmentImage(data: IPulsaraAttachmentImageRequest): Promise<IPulsaraAttachmentImageResponse> {
    return this.get(fetchPulsaraAttachmentImageUrl(data.pulsaraId, data.attachmentId))
  }
}
